"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSearchRequest = exports.lastSearchTerm = exports.resultResponse = exports.error = exports.fetching = void 0;
var vue_1 = require("vue");
var axios_1 = require("@ocm/axios");
var use_trackingInteractions_1 = require("@/composables/use-trackingInteractions");
var use_trackingErrors_1 = require("@/composables/use-trackingErrors");
var router_1 = require("@/router");
exports.fetching = (0, vue_1.ref)(false);
exports.error = (0, vue_1.ref)();
exports.resultResponse = (0, vue_1.ref)();
exports.lastSearchTerm = (0, vue_1.ref)();
var getSearchRequest = function (input) { return __awaiter(void 0, void 0, void 0, function () {
    var result, err_1, numberOfResultsOrError;
    var _a, _b;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 2, 3, 4]);
                router_1.default.push({ query: { search: input } });
                exports.fetching.value = true;
                exports.resultResponse.value = undefined;
                return [4 /*yield*/, axios_1.$axios.get("rest/contactcenter/search", {
                        params: { query: input },
                    })];
            case 1:
                result = _c.sent();
                exports.lastSearchTerm.value = input;
                exports.resultResponse.value = result.data.data.search.results;
                exports.error.value = "";
                return [3 /*break*/, 4];
            case 2:
                err_1 = _c.sent();
                if (err_1.response.status === 400) {
                    exports.error.value = "missing_characters_error";
                    (0, use_trackingErrors_1.trackSearchTermNotLongEnough)(input);
                }
                else {
                    exports.error.value = "generic_error";
                    (0, use_trackingErrors_1.trackSearchSubmitUnforeseenError)(err_1.response);
                }
                return [3 /*break*/, 4];
            case 3:
                exports.fetching.value = false;
                numberOfResultsOrError = (_b = (_a = exports.resultResponse.value) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : exports.error.value;
                (0, use_trackingInteractions_1.trackSearchTerm)(input, numberOfResultsOrError);
                return [7 /*endfinally*/];
            case 4: return [2 /*return*/];
        }
    });
}); };
exports.getSearchRequest = getSearchRequest;
